import React from "react";
import { NavLink  } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";


const HomeCategories = () => {
  const Brand = {
    data: [
        {  img1:"/images/brands-logo/brand1.jpg"},  
        {  img1:"/images/brands-logo/brand2.jpg"}, 
        {  img1:"/images/brands-logo/brand3.jpg"}, 
        {  img1:"/images/brands-logo/brand4.jpg"},  
        {  img1:"/images/brands-logo/brand5.jpg"}, 
        {  img1:"/images/brands-logo/brand6.jpg"},
        {  img1:"/images/brands-logo/brand7.jpg"},  
        {  img1:"/images/brands-logo/brand8.jpg"}, 
        {  img1:"/images/brands-logo/brand9.jpg"},  
        {  img1:"/images/brands-logo/brand10.jpg"},  
        {  img1:"/images/brands-logo/brand11.jpg"}, 
        {  img1:"/images/brands-logo/brand1.jpg"}, 
      
        
    ],
  };
  return (
    <section className="py-5">
     

<div className="container brands-wrapper mt-5">
<div className="heading text-center pb-2">
<h2>Brands we are dealing</h2>

</div>
<div className="row">
{Brand.data.map((item, index)=>(
  <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
            <div className="wrapper">
            <div className="img-wrapper">
            <img src={item.img1} alt="brands" />
            </div>
            
            </div>
          </div>
))
}
          
         
        </div>

</div>

    </section>
  );
};

export default HomeCategories;
